<app-riders-filters (onFilter)="onFilter($event)" [defaultFilters]="defaultFilters">
</app-riders-filters>

<div class="riders-container">
    <table mat-table matSort [dataSource]="riders" multiTemplateDataRows matSortDisableClear matSortActive="name" matSortDirection="asc">
        <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Nome </th>
            <td mat-cell *matCellDef="let rider"> {{ rider.name }} </td>
        </ng-container>
        <ng-container matColumnDef="surname">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Cognome </th>
            <td mat-cell *matCellDef="let rider"> {{ rider.surname}} </td>
        </ng-container>
        <ng-container matColumnDef="phone">
            <i class="material-icons">phone</i>&nbsp;&nbsp;&nbsp;
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Telefono </th>
            <td mat-cell *matCellDef="let rider"> {{ rider.phone ? rider.phone : '-' }} </td>
        </ng-container>
        <!-- <ng-container matColumnDef="dailyAmount">
            <i class="material-icons">fastfood</i>&nbsp;&nbsp;&nbsp;
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Consegne effettuate in giornata </th>
            <td mat-cell *matCellDef="let rider"> {{ rider.dailyOrders?.length }} </td>
        </ng-container>
        <ng-container matColumnDef="dailyOrders">
            <i class="material-icons">attach_money</i>&nbsp;&nbsp;&nbsp;
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Incasso totale della giornata </th>
            <td mat-cell *matCellDef="let rider"> {{ rider.dailyAmount | number:'1.2-2' }}€ </td>
        </ng-container> -->

        <ng-container matColumnDef="email">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Email </th>
            <td mat-cell *matCellDef="let rider"> {{ rider.email }} </td>
        </ng-container>

        <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef class="add-icon-container">
                <button mat-mini-fab *ngIf="canAdd" matTooltip="Nuovo fattorino" (click)="$event.stopPropagation(); addRider()" color="primary">
                    <mat-icon>add</mat-icon>
                </button>
            </th>
            <td mat-cell *matCellDef="let row" class="modify-icon-container">
                <ng-container *ngIf="canEdit">
                    <button mat-icon-button (click)="$event.stopPropagation(); editRider(row)">
                        <mat-icon matTooltip="Modifica">create</mat-icon>
                    </button>
                </ng-container>
            </td>
        </ng-container>
        
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns" (click)="editRider(row)"></tr>
    </table>

    <mat-paginator     [pageSizeOptions]="pageSizeOptions"
  [pageSize]="pageSizeOptions[0]"
  [length]="total | async">
  </mat-paginator>

</div>